import { render, staticRenderFns } from "./FileActions.vue?vue&type=template&id=2b1ae8e2&"
import script from "./FileActions.vue?vue&type=script&lang=js&"
export * from "./FileActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports